import { f, y } from "@iplusplus/y-model"
import { Size } from "../types"
import { TypedControl } from "../TypedControl"

const PropDefine = f([["remark", "说明", "string", y.string("该控件已被移除")]] as const)

const typeName = "EmptyControl"
const title = "空控件"
export class EmptyControl extends TypedControl<typeof PropDefine> {
  run(): void {}
  getDefaultSize(): Size {
    return { width: 50, height: 50 }
  }
  reDraw(): void {}
  constructor() {
    super(PropDefine, { typeName, title }, undefined)
  }
}
